import { ThankYouComponent } from './public/thank-you/thank-you.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ModuleGuard } from './shared/guard/module/module.guard';
import { CodeLoginErrorComponent } from './shared/components/code-login-error/code-login-error.component';
import { HomeGuard } from './shared/guard/home/home.guard';
import { LandingPageComponent } from './shared/components/landing-page/landing-page.component';
import { InvitationComponent } from './public/invitation/invitation.component';
import { InvitationResolverComponent } from './public/invitation-resolver/invitation-resolver.component';
// import { PublicComponent } from './public/public.component';

const routes: Routes = [
  // {
  //   path: '',
  //   pathMatch: 'full',
  //   redirectTo: '',
  // },
  {
    path: '',
    loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule)
  },
  {
    path: 'apps',
    component: LandingPageComponent,
    canActivate: [ModuleGuard]
  },
  {
    path: 'grievance_link',
    loadChildren: () => import('./modules/worker/worker.module').then(m => m.WorkerModule)
  },
  {
    path: 'vms',
    title: 'VMS',
    loadChildren: () =>
      import('./modules/vms/vms.module').then((m) => m.VmsModule),
    canActivate: [ModuleGuard]
  },
  {
    path: 'admin',
    title: 'Admin',
    loadChildren: () =>
      import('./modules/admin/admin.module').then((m) => m.AdminModule),
    canActivate: [ModuleGuard]
  },
  {
    path: 'account',
    title: 'Account',
    loadChildren: () =>
      import('./modules/account/account.module').then((m) => m.AccountModule),
    // canActivate: [ModuleGuard]
  },
  {
    path: 'mrb',
    title: 'MRB',
    loadChildren: () =>
      import('./modules/mrb/mrb.module').then((m) => m.MrbModule),
    canActivate: [ModuleGuard]
  },

  {
    path: 'dms',
    title: 'Documents',
    loadChildren: () =>
      import('./modules/documents/routes/documents.routes').then((m) => m.DOCUMENTS_ROUTES),
    canActivate: [ModuleGuard]
  },

  {
    path: 'code-login-error',
    component: CodeLoginErrorComponent
  },
  {
    path: 'review/:encodedId',
    loadChildren: () => import('./public/feedback/feedback.module').then(m => m.FeedbackModule)
  },
  {
    path: 'thank-you-page',
    component: ThankYouComponent
  },
  {
    path: 'invitation/:token',
    component: InvitationComponent
  },
  {
    path: 'vendor-creation/invite/:token',
    loadComponent: () => import('./public/vendor-creation-invite/vendor-creation-invite.component').then(c => c.VendorCreationInviteComponent)
  },
  {
    path: 'vendor-creation/invite',
    redirectTo: 'code-login-error',
    pathMatch: 'full'
  },
  {
    path: 'inv/:code',
    component: InvitationResolverComponent
  },

  {
    path: 'grievance',
    loadChildren: () => import('./modules/grievance/grievance.module').then(m => m.GrievanceModule),
    canActivate: [HomeGuard]
  },

  {
    path: 'expense',
    title: 'Trip And Expense',
    loadChildren: () => import('./modules/expense/expense.module').then(m => m.ExpenseModule),
    canActivate: [ModuleGuard]
  },
  {
    path: 'conference-room',
    title: 'Conference Room',
    loadChildren: () => import('./modules/conference-room/conference-room.module').then(m => m.ConferenceRoomModule),
    canActivate: [HomeGuard]
  },
  {
    path: 'ams',
    loadChildren: () => import('./modules/ams/ams.module').then(m => m.AmsModule),
    canActivate: [HomeGuard]
  },
  {
    path: 'ai-buddy',
    title: 'AI Buddy',
    loadChildren: () => import('./modules/ai-buddy/ui/ai-buddy.module').then(m => m.AiBuddyModule),
    canActivate: [ModuleGuard]
  },

  {
    path: 'approval-notes',
    title: 'Approval Notes',
    loadChildren: () => import('./modules/approval_notes/routes/approval-notes.routes').then(m => m.APPROVAL_NOTES_ROUTES),
    canActivate: [ModuleGuard]
  },

  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
